import { useRef, useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

// Simplified global animated background - calmer, cleaner
export const Scene3D = () => {
  const { scrollYProgress } = useScroll();
  
  const mainOrbY = useTransform(scrollYProgress, [0, 1], ['30%', '70%']);
  const mainOrbOpacity = useTransform(scrollYProgress, [0, 0.5, 1], [0.15, 0.2, 0.12]);

  return (
    <div 
      className="fixed inset-0 overflow-hidden pointer-events-none z-0"
      style={{ background: 'linear-gradient(to bottom, #0E0F14, #0A0B0F)' }}
    >
      {/* Subtle gradient overlay */}
      <div 
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 80% 50% at 50% 30%, rgba(108, 77, 255, 0.06), transparent)',
        }}
      />
      
      {/* Main central glow - subtle */}
      <motion.div
        className="absolute left-1/2 -translate-x-1/2"
        style={{
          top: mainOrbY,
          opacity: mainOrbOpacity,
        }}
      >
        <div className="w-[500px] h-[500px] rounded-full bg-[#6C4DFF]/20 blur-[150px]" />
      </motion.div>

      {/* Secondary accent glow */}
      <motion.div 
        className="absolute top-[20%] left-[15%]"
        animate={{
          y: [-10, 10, -10],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <div className="w-32 h-32 rounded-full bg-[#8468FF]/12 blur-[80px]" />
      </motion.div>

      <motion.div 
        className="absolute bottom-[30%] right-[15%]"
        animate={{
          y: [10, -10, 10],
        }}
        transition={{
          duration: 7,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }}
      >
        <div className="w-28 h-28 rounded-full bg-[#32D583]/10 blur-[70px]" />
      </motion.div>

      {/* Minimal floating particles - reduced count */}
      <div className="absolute inset-0">
        {[...Array(12)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-[#6C4DFF]/30"
            style={{
              left: `${8 + (i * 7.5) % 84}%`,
              top: `${10 + (i * 8.3) % 80}%`,
              width: 2,
              height: 2,
            }}
            animate={{
              y: [0, -20, 0],
              opacity: [0.2, 0.5, 0.2],
            }}
            transition={{
              duration: 5 + (i % 3),
              repeat: Infinity,
              delay: (i * 0.3) % 2,
              ease: "easeInOut"
            }}
          />
        ))}
      </div>

      {/* Ambient gradients */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-[#0E0F14] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0A0B0F] to-transparent" />
    </div>
  );
};
